module.exports = __webpack_public_path__ + "img/banner.af233d69.jpg";